export const API_URL = 'https://testapi.codeamooz.com';
